import { ObjectHelper } from "../Helpers/ObjectHelper";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerLessThanOrEqualToPropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerLessThanOrEqualToProperties = {
    [name in keyof PropertyComparerLessThanOrEqualToPropertyValues]: Property<PropertyComparerLessThanOrEqualToPropertyValues[name]>
};

export interface IPropertyComparerLessThanOrEqualTo extends IPropertyComparer, PropertyComparerLessThanOrEqualToProperties
{
}

export class PropertyComparerLessThanOrEqualTo extends PropertyComparer<PropertyComparerLessThanOrEqualToPropertyValues> implements IPropertyComparerLessThanOrEqualTo
{
    public static override classNamespace = NAMESPACE + "PropertyComparerLessThanOrEqualTo";
    public static override className = "PropertyComparerLessThanOrEqualTo";

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return ObjectHelper.compare(propertyValue, constantValue) <= 0;
    }

    // #endregion
}

